export const defaultStatusTheme = {
	operational: '#5EB870',
	minor: '#FCB900',
	major: '#F27641',
	critical: '#E15554',
}
